import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=15768f9c"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports